import * as types from "../../constants";

export default function reducer(
  state = {
    user: {
      email: null,
      name: null,
      balance: JSON.parse(sessionStorage.getItem("token_store"))
        ? JSON.parse(sessionStorage.getItem("token_store")).balance
        : null,
    },
  },
  actions
) {
  switch (actions.type) {
    case types.AUTH_SIGN_IN_SUCCESS:
      return {
        ...state,
        user: {
          email: actions.email,
          name: actions.name,
          balance: actions.balance,
        },
      };

    case types.AUTH_USER_BALANCE_UPDATE_SUCCESS:
      return {
        ...state,
        user: {
          email: actions.email,
          name: actions.name,
          balance: actions.balance,
        },
      };

    case types.AUTH_SIGN_OUT:
      return {
        ...state,
        user: undefined,
      };

    default:
      return state;
  }
}
